import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const DownloadVDRFile = createAsyncThunk(
    'dataRoom/downloadFile',
    async (
        {
            engagementId,
            answerFileId,
        }: { engagementId: number; answerFileId: number },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.get(
                `api/VirtualDataRoomDocument/${engagementId}/file/${answerFileId}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not download file at the moment.',
                    'error'
                );
                throw new Error('Failed to download file');
            }

            return response.data as string;
        } catch (error) {
            createNotification(
                'An error occurred while downloading file.',
                'error'
            );
            throw error;
        }
    }
);

